



















import Vue from 'vue';
import { Modal, ModalMixin } from 'mycorems-app-shared';
import { ModalElement } from '@/types';

export default Vue.extend({
  mixins: [ModalMixin],
  props: {
    title: {
      type: String,
      default: 'Confirmation',
    },
  },
  methods: {
    onOk(): void {
      this.$emit('ok');
      (this.$refs.modal as ModalElement).hide();
    },
  },
  components: {
    modal: Modal,
  },
});
